(function () {
  'use strict';

  const STORAGE_KEY = 'cart:upsell-widget-open';
  const WIDGET_SELECTOR = '[data-upsell-widget]';
  const BODY_SELECTOR = '[data-collapsible-body]';

  const getWidget = () => document.querySelector(WIDGET_SELECTOR);

  const setOpen = (widget, open) => {
    const body = widget.querySelector(BODY_SELECTOR);

    if (open) {
      widget.setAttribute('open', true);
      if (body) body.style.height = 'auto';
    } else {
      widget.removeAttribute('open');
      if (body) body.style.height = '';
    }
  };

  const applyStoredState = () => {
    const widget = getWidget();
    if (!widget) return;

    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'true' || stored === 'false') {
      setOpen(widget, stored === 'true');
    }
  };

  const bindToggleListener = () => {
    const widget = getWidget();
    if (!widget || widget.dataset.upsellPersistBound) return;

    widget.dataset.upsellPersistBound = 'true';
    widget.addEventListener('theme:collapsible:toggle', () => {
      window.localStorage.setItem(STORAGE_KEY, widget.getAttribute('open') === 'true');
    });
  };

  const init = () => {
    bindToggleListener();
    applyStoredState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('theme:cart:change', () => {
    bindToggleListener();
    applyStoredState();
  });
})();
